
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[slug]/products",
      function () {
        return require("private-next-pages/store/[slug]/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[slug]/products"])
      });
    }
  